<template>
<div class='profile-api'>
  <div v-if="apiEnabled">
    <div class='pane'>
      <p class='title'>
        API 信息
      </p>
      <el-form label-width="160px" label-position="right">
        <el-form-item label="API 服务器">
          <el-input :readonly="true" v-model="form.api_endpoint"></el-input>
        </el-form-item>

        <el-form-item label="Access Key">
          <el-input :readonly="true" v-model="form.access_key"></el-input>
        </el-form-item>

        <!-- <el-form-item label="Secret Key">
          <el-input :readonly="true" v-model="form.secret_key"></el-input>
        </el-form-item> -->

        <el-form-item label="API 类型">
          <span>{{form.sandbox ? '测试' : '正式'}}</span>
        </el-form-item>

        <el-form-item label="调用统计">
          <span>{{Number(form.quotas) - Number(form.quotas_left)}}/{{Number(form.quotas)}}</span>
        </el-form-item>

        <el-form-item label="开发文档">
          <a href="https://ppninja.github.io/saas-docs/#introduction" target="_blank" class='text-btn'>点击访问</a>
        </el-form-item>
      </el-form>
    </div>

    <div class='pane'>
      <p class='title'>
        调用配置
      </p>
      <el-form label-width="160px" label-position="right">
        <el-form-item label="回调地址" :error="errors.first('notify_url')">
          <el-input v-model="form.notify_url" placeholder="可选"></el-input>
        </el-form-item>

        <el-form-item label="IP 白名单" :error="errors.first('ip_whitelist')">
          <el-input v-model="form.ip_whitelist" placeholder="可选"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="save('request')">保存</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class='pane'>
      <p class='title'>
        生成配置
      </p>
      <el-form label-width="160px" label-position="right">
        <el-form-item label="开放页面控制接口">
          <el-tooltip :disabled="form.page_ctrl_api_entitled" content="请联系管理员打开权限" effect="dark" placement="top">
            <div style="width: 35px;">
              <el-switch reserve :disabled="true" theme='info' :width="35" v-model="form.page_ctrl_api_entitled" on-text="" off-text="">
              </el-switch>
            </div>
          </el-tooltip>
        </el-form-item>

        <el-form-item label="嵌入js代码">
          <el-input type="textarea" :rows="4" v-model="form.injected_code" placeholder="console.log('hello, world!');"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="save('generate')">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
  <div class='pane' v-else>
    <p class='title'>您尚未开通 API 服务，<a @click="apiApplication">点击申请</a></p>
  </div>
</div>
</template>

<script>
import { createDialog } from '@/assets/scripts/dialog'
import validator from '@/mixins/validator'
import applicationDialog from './application.dialog'

export default {
  data() {
    return {
      applyDialog: createDialog(applicationDialog),
      form: {
        api_endpoint: null,
        access_key: null,
        secret_key: null,
        notify_url: null,
        sandbox: null,
        quotas: null,
        quotas_left: null,
        ip_whitelist: null,
        page_ctrl_api_entitled: false,
        injected_code: null
      }
    }
  },
  mixins: [validator],
  computed: {
    apiEnabled() {
      return this.$store.state.user.info.api_entitled || (this.$store.getters['user/organization'] && this.$store.getters['user/organization'].api_entitled)
    }
  },
  methods: {
    apiApplication() {
      this.applyDialog()
    },
    save(paramsSelector) {
      let vm = this

      let _params = {}
      if (paramsSelector === 'request') {
        _params = {
          notify_url: vm.form.notify_url,
          ip_whitelist: vm.form.ip_whitelist
        }
      } else if (paramsSelector === 'generate') {
        _params = {
          injected_code: vm.form.injected_code
        }
      }

      vm.$store.dispatch('apis/updateApis', _params).then(res => {
        vm.form = JSON.parse(JSON.stringify(res.data))
      }).catch(err => {
        let data = err.response.data

        if (data.type === 'RecordInvalidError') {
          data.errors.forEach(e => {
            vm.errors.add(e.field, e.details[0].message)
          })
        }
      })
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.$store.dispatch('apis/apiInfo').then(res => {
        vm.form = JSON.parse(JSON.stringify(res.data))
      })
    })
  }
}
</script>

<style lang="scss" scoped>
.profile-api {
    .pane {
        .title {
            color: $font-color-strong;
            font-size: 16px;
            margin-top: 0;
            line-height: 2em;

            a {
                font-size: $font-size-base;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// index.vue?39a2f6e6